import React, { Component } from "react";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";

class CustomTableHead extends Component {
  render() {
    const { numSelected, rowCount, onSelectAllClick } = this.props;
    return (
      <TableHead>
        <TableRow>
          {this.props.showCheckbox && (
            <TableCell align="center">
              <Checkbox
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={rowCount > 0 && numSelected === rowCount}
                onChange={onSelectAllClick}
                inputProps={{ "aria-label": "select all desserts" }}
              />
            </TableCell>
          )}
          {this.props.column.map((column, index) => (
            <TableCell
              key={index}
              align="center"
              style={{ fontWeight: "bold" }}
            >
              {column.name}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
}

export default CustomTableHead;
